export const name = 'siteThemeService' as const
export const VIEWER_SERVICE_PACKAGE_NAME = '@wix/viewer-service-site-theme' as const
